const initialVendorReportState = {
    VendorReport_Tab12025: { top_description: "", bullets : ""},
    VendorReport_Tab2: { top_description: "", bullets : ""},
    VendorReport_Tab3: { top_description: "", bullets : ""},
    VendorReport_Tab4: { top_description: "", bullets: "" },
    VendorReport_MatchRateTab: { bvd_match: "" },
    mapRawData: null,
    lqFlowerRawData: null,
    spendingFlowerRawData: null,
    bsRawData: null,
    bsLQType: "lq_wgt_annual_avg_emplvl",
    QCEWNaicsLevel: 2,
    QCEWTopText: {
        matched_business_total_amt: null,
        matched_business_pmt_pct: null
    },
    clickedFips: null,
    hoveredChart: null,
    tooltipData: null,
    SunburstData_Updated: null,
    SunburstBVDData_Updated: null,
    selected_year: null,
    vendorRelease: "Not Available",
}

export default function (state = initialVendorReportState, action) {
    let propertyName: string;

    switch (action.type) {
        case "VENDOR_REPORT_LOADING":
            return action.payload;
        case "HOMESTATE2025":
            propertyName = "HomeState";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "INSTITUTION_NAME":
            propertyName = "institutionName";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;    
        case "SELECTED_YEAR":
            propertyName = "selected_year";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "REPORTS_CONF":
            propertyName = "ReportsConf";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        //this is vendor tab1 reimagined year 2025 starts
        case "VENDOR_PROFILE_TAB1_ALL_DATA":
            propertyName = "VendorProfileTab1AllData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_VENDOR_PROFILES_BY_YEAR2025":
            propertyName = "VendorProfilesByYear";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "VENDOR_TAB1":
            propertyName = "VendorReport_Tab12025";
            var newState = Object.assign({}, state);

            newState[propertyName].minYear = action.payload.minYear;
            newState[propertyName].maxYear = action.payload.maxYear;
            newState[propertyName].selectedYear = action.payload.selectedYear;
            newState[propertyName].isAgg = action.payload.isAgg;
            newState[propertyName].topDescription = action.payload.topDescription;
            newState[propertyName].highlightsYearRange = action.payload.highlightsYearRange;
            newState[propertyName].highlightsSelectedYear = action.payload.highlightsSelectedYear;
            newState[propertyName].benchmarkingDescription = action.payload.benchmarkingDescription;
            newState[propertyName].benchmarkingHighlights = action.payload.benchmarkingHighlights;
            newState[propertyName].highlights = action.payload.highlights;
            newState[propertyName].vendorRelease = action.payload.vendorRelease;
            newState[propertyName].benchmarkUniversityList = action.payload.benchmarkUniversityList;
            newState[propertyName].allMemberUniversities = action.payload.allMemberUniversities;
            return newState;
        case "SELECTED_YEAR_CHANGE":
            propertyName = "VendorReport_Tab12025";
            var newState = Object.assign({}, state);
            newState[propertyName].selectedYear = action.payload.selectedYear;
            newState[propertyName].highlightsSelectedYear = action.payload.highlightsSelectedYear;
            newState[propertyName].benchmarkingHighlights = action.payload.benchmarkingHighlights;
            newState[propertyName].benchmarkingDescription = action.payload.benchmarkingDescription;
            if (action.payload.benchmarkUniversityList !== undefined) {
                newState[propertyName].benchmarkUniversityList = action.payload.benchmarkUniversityList;
            }
            return newState;
        //this is vendor tab1 reimagined year 2025 ends
        
        case "NAICS_LEVEL_CHANGE":
            propertyName = "selectedNaicsLevel";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "US_STATE":
            propertyName = "USStateList";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "VENDOR_MATCH_RATE":
            propertyName = "VendorMatchRate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "DOWNLOAD":
            return state;

        case "VENDOR_TAB1_SECTION2_TEXT":
            propertyName = "VendorReport_Tab12025";
            var newState = Object.assign({}, state);
            newState[propertyName].section2_text = action.payload.section2_text;
            return newState;

        case "VENDOR_TAB2":
            propertyName = "VendorReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].top_description = action.payload.top_description;
            newState[propertyName].bullets = action.payload.bullets;
            newState[propertyName].section1_text = action.payload.section1_text;
            newState[propertyName].section2_text = action.payload.section2_text;
            newState[propertyName].section1_heading = action.payload.section1_heading;
            newState[propertyName].section2_heading = action.payload.section2_heading;

            newState[propertyName].IndustryMapTotals = action.payload.IndustryMapTotals;
            newState[propertyName].FlowerMapSpending = action.payload.FlowerMapSpending;


            return newState;
        case "VENDOR_TAB2_CAMPUSNAME":
            propertyName = "VendorReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].campus_name = action.payload.campus_name;
            return newState;
        case "VENDOR_TAB2_QCEWYear":
            propertyName = "VendorReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].QCEWYear = action.payload.QCEWYear;
            return newState;

        case "VENDOR_TAB3":
            propertyName = "VendorReport_Tab3";
            var newState = Object.assign({}, state);
            newState[propertyName].title = action.payload.title;
            newState[propertyName].top_description = action.payload.top_description;
            newState[propertyName].bullets = action.payload.bullets;
            newState[propertyName].instructions = action.payload.instructions;
            newState[propertyName].BVDYearRange_min_year = action.payload.BVDYearRange_min_year;
            newState[propertyName].BVDYearRange_max_year = action.payload.BVDYearRange_max_year;
            return newState;

        case "SUNBURSTDATA_UPDATED":
            propertyName = "SunburstData_Updated";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.decoratedData;
            return newState;

        case "VENDOR_TAB4":
            propertyName = "VendorReport_Tab4";
            var newState = Object.assign({}, state);
            newState[propertyName].title = action.payload.title;
            newState["decordatedBVDData"] = action.payload.decordatedBVDData;
            newState[propertyName].top_description = action.payload.top_description;
            newState[propertyName].bullets = action.payload.bullets;
            newState[propertyName].instructions = action.payload.instructions;
            newState[propertyName].chartTooltip= action.payload.chartTooltip;
            newState[propertyName].top_industry_spending_to_date = action.payload.top_industry_spending_to_date;
            newState[propertyName].bvd_match_rates_inflation_year = action.payload.bvd_match_rates_inflation_year;
            newState[propertyName].BVDYearRange_start_fy = action.payload.BVDYearRange_start_fy;
            newState[propertyName].BVDYearRange_end_fy = action.payload.BVDYearRange_end_fy;
            return newState;
            
        case "VENDOR_MATCHTAB":
            propertyName = "VendorReport_MatchRateTab";
            var newState = Object.assign({}, state);
            newState[propertyName].bvd_match = action.payload.bvd_match;
            return newState;

        case "SUNBURSTBVDDATA_UPDATED":
            propertyName = "SunburstBVDData_Updated";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.decoratedData;
            return newState;

        case "VENDOR_TAB1_BULLETS":
            propertyName = "VendorReport_Tab12025";
            var newState = Object.assign({}, state);
            newState[propertyName].bullets = action.payload.bullets;
            return newState;

        case "GET_TREND_LINES_PARAGRAPH":
            propertyName = "TrendsPar";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        
        case "GET_SUNBURST_DATA":
            propertyName = "SunburstData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "VENDOR_RELEASE":
            propertyName = "vendorRelease";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_SUNBURST_BVD_DATA":
            propertyName = "SunburstBVDData";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "GET_BVD_SUNBURST_BULLETPOINT":
            propertyName = "SunburstBulletPoint";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "GET_BVD_MATCHRATES":
            propertyName = "BVDMatchRates";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "CENSUS_YEAR_RANGE":
            propertyName = "CensusYearRange";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "GET_VENDOR_SPENDING_MAP_DATA":
            return { ...state, mapRawData: action.payload };

        case "GET_LQ_FLOWER_DATA":
            return { ...state, lqFlowerRawData: action.payload };
        case "GET_SPENDING_FLOWER_DATA":
            return { ...state, spendingFlowerRawData: action.payload };

        case "GET_BEESWARM_DATA":
            return { ...state, bsRawData: action.payload };

        case "RESET_FIPS_TO_NULL":
            return { ...state, clickedFips: action.payload };
        case "REVERT_FIPS_TO_STATEFIPS":
            return { ...state, clickedFips: action.payload };

        case 'SET_CLICKED_FIPS':
            return { ...state, clickedFips: action.payload, hoveredChart: null, tooltipData: null };

        case "MOUSE_OVER_MAP_NODE":
            return { ...state, hoveredChart: "map", tooltipData: action.payload };
        case "MOUSE_OUT_MAP_NODE":
            return { ...state, hoveredChart: null, tooltipData: null };

        case "MOUSE_OVER_FLOWER":
            return { ...state, hoveredChart: "flower", tooltipData: action.payload };
        case "MOUSE_OUT_FLOWER":
            return { ...state, hoveredChart: null, tooltipData: null };

        case "MOUSE_OVER_BEESWARM":
            return { ...state, hoveredChart: "beeswarm", tooltipData: action.payload };
        case "MOUSE_OUT_BEESWARM":
            return { ...state, hoveredChart: null, tooltipData: null };

        case "CHANGE_QCEW_NAICS_LEVEL":
            return {
                ...state, QCEWNaicsLevel: action.payload,
                spendingFlowerRawData: null, lqFlowerRawData: null, bsRawData: null
            };
        case "CHANGE_LQ":
            return { ...state, bsLQType: action.payload }
        default:
            return state;
    }
}